<br />
<br />
<h4 style="font-weight:bold; text-decoration:underline; text-align:center">CLAIM FORM INSTRUCTIONS</h4>
<br />
<div class="container" style="border:1px solid #bebaba">
  <div class="container-fluid">
    <div row>
      <div class="col-md-12">
        <br /><br />
        Generally, you are included in the Settlement as part of the Nationwide Class if you are in the United States, were charged a surcharge
        (or access fee) to withdraw cash from your deposit account using an ATM or pin-debit card at an independent ATM located in the United
        States (including its territories) between October 24, 2007, and August 14, 2026, and were not fully reimbursed by your bank. You may
        also be included as part of the Statewide Classes for California, Illinois, Massachusetts, and Michigan.<br /><br />

        <ul>
          <li>
            An Independent ATM (or “IATM”) is an automated teller machine that is not owned by Visa, Mastercard, or any bank or other financial
            institution. A domestic cash withdrawal transaction is a transaction to withdraw cash from a customer’s deposit account using an ATM
            or pin-debit card at an IATM terminal located within the United States, including its territories. It does not include any credit
            card transaction or any transaction involving a cash advance or prepaid card.<br /><br />
          </li>
        </ul>

        <b>You must fill out and submit your Claim Form no later than February 10, 2027.</b><br /><br />

        <b>Settlement payments will be sent to you digitally via email</b>. Please provide a current, valid email address and mobile phone number
        on your Claim Form. If the email address or mobile phone number you provided becomes invalid for any reason, it is your responsibility to
        provide accurate contact information to the Claims Administrator to get your payment.<br /><br />

        When you receive the email and/or mobile phone text notifying you about your Settlement payment, you will be provided with a number of
        digital payment options, such as PayPal or a virtual debit card, to immediately receive your Settlement payment. At that time, you will
        also have the option to ask for a paper check.<br/><br/>

        The information you provide on this Claim Form will be used solely by the Court-approved Claims Administrator to administer the Settlement
        and will not be provided to any third party or sold for marketing purposes.<br/><br/>

        You do not need to provide any documentation at this time. However, the Claims Administrator may ask you for additional documentation or
        proof that supports your claim.<br/><br/>
      </div>
    </div>
    <div class="row mt-5" style="margin-left: 0px; margin-right: 0px">
      <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
        Claimant Information 
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="claimantsInformation" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="name1">NAME:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="name1" formControlName="name1" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.name1.errors }" />
                <div *ngIf="submitted && f.name1.errors" class="invalid-feedback">
                  <div *ngIf="f.name1.errors.required">This field is required</div>
                  <div *ngIf="f.name1.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.name1.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.name1.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="street1">STREET ADDRESS 1:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="street1" formControlName="street1" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street1.errors }" />
                <div *ngIf="submitted && f.street1.errors" class="invalid-feedback">
                  <div *ngIf="f.street1.errors.required">This field is required</div>
                  <div *ngIf="f.street1.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.street1.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.street1.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="street2">STREET ADDRESS 2:</label>
                <input type="text" class="form-control" id="street2" formControlName="street2" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.street2.errors }" />
                <div *ngIf="submitted && f.street2.errors" class="invalid-feedback">
                  <div *ngIf="f.street2.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.street2.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.street2.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="city"><b>CITY</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
                <div *ngIf="(changed || submitted) && f.city.errors" class="invalid-feedback">
                  <div *ngIf="f.city.errors.required">This field is required</div>
                  <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.city.errors.maxlength">This field must not be at greater 40 characters</div>
                  <div *ngIf="f.city.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets,
                    ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="state"><b>STATE</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                  <option value="">Please Select A State</option>
                  <option *ngFor="let allstate of allStates">
                    {{allstate.Name}}
                  </option>
                </select>
                <div *ngIf="(changed || submitted) && f.state.errors" class="invalid-feedback">
                  <div *ngIf="f.state.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="zip"><b>ZIP CODE</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
                <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
                  <div *ngIf="f.zip.errors.required">This field is required</div>
                  <div *ngIf="f.zip.errors.pattern">
                    US zip Code with format 99999 or 99999-9999 alone are
                    accepted
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="primaryPhone">PHONE NUMBER:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" mask="000 000-0000" class="form-control" id="primaryPhone" formControlName="primaryPhone" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.primaryPhone.errors }" />
                <div *ngIf="submitted && f.primaryPhone.errors" class="invalid-feedback">
                  <div *ngIf="f.primaryPhone.errors.required">This field is required</div>
                  <div *ngIf="f.primaryPhone.errors.minlength">This field must be at least 10 digits</div>
                  <div *ngIf="f.primaryPhone.errors.maxlength">This field must not be at greater 10 digits</div>
                  <div *ngIf="f.primaryPhone.errors.pattern">Only use numbers</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="primaryPhoneType">PHONE NUMBER TYPE:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="primaryPhoneType" [ngClass]="{ 'is-invalid': submitted && f.primaryPhoneType.errors }">
                  <option value="">Please Select Phone Type</option>
                  <option value="Cell">Cell</option>
                  <option value="Landline">Landline</option>
                </select>
                <div *ngIf="submitted && f.primaryPhoneType.errors" class="invalid-feedback">
                  <div *ngIf="f.primaryPhoneType.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="emailAddress"><b>EMAIL ADDRESS:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.emailAddress.errors }" />
                <div *ngIf="f.emailAddress.errors" class="invalid-feedback">
                  <div *ngIf="f.emailAddress.errors.required">This field is required</div>
                  <div *ngIf="f.emailAddress.errors.maxlength">This field must not be greater than 255 characters</div>
                  <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
                  <div *ngIf="f.emailAddress.errors.mustMatch">Email Addresses must match</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat">
            <div class="col-md-12">
              <div class="form-group">
                <label for="emailAddressVerify"><b>VERIFY EMAIL ADDRESS:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <input type="text" class="form-control" formControlName="emailAddressVerify" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.emailAddressVerify.errors }" />
                <div *ngIf="f.emailAddressVerify.errors" class="invalid-feedback">
                  <div *ngIf="f.emailAddressVerify.errors.required">This field is required</div>
                  <div *ngIf="f.emailAddressVerify.errors.maxlength">This field must not be greater than 255 characters</div>
                  <div *ngIf="f.emailAddressVerify.errors.pattern">This is not a valid email address</div>
                  <div *ngIf="f.emailAddressVerify.errors.mustMatch">Email Addresses must match</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              To get a payment, you <b><u>must</u></b> provide a current, valid email address and/or mobile phone number on
              this Claim Form. If the email address or mobile phone number you provide becomes invalid for any reason, it is
              your responsibility to give the Claims Administrator your updated email address and mobile phone number.
              Otherwise, you may not get paid.
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-md-12">

              <b>
                WERE YOU CHARGED AN UNREIMBURSED SURCHARGE (OR ACCESS FEE) TO WITHDRAW CASH FROM AN INDEPENDENT ATM IN
                THE UNITED STATES (OR ITS TERRITORIES) BETWEEN OCTOBER 24, 2007, AND AUGUST 14, 2026?
                <span style="color:red; font-weight:bold" class="required"> *This is Required</span>
                <br />
              </b>

              <div class="row">
                <div class="col-md-12">
                  <div class="radio">
                    <label for="chargedUnreimbursedSurcharge">
                      <input type="radio" id="chargedUnreimbursedSurchargeYes" formControlName="chargedUnreimbursedSurcharge" (change)="getQuestionOneValue($event)" name="chargedUnreimbursedSurcharge" value="Yes"><span style="font-weight:bold">Yes</span>
                    </label>
                  </div>
                  <div class="radio">
                    <label for="chargedUnreimbursedSurcharge">
                      <input type="radio" id="chargedUnreimbursedSurchargeNo" formControlName="chargedUnreimbursedSurcharge" (change)="getQuestionOneValue($event)" name="chargedUnreimbursedSurcharge" value="No"><span style="font-weight:bold">No</span>
                    </label>
                  </div>
                </div>
              </div>

              <div *ngIf="showQuestionTwo == true">

                <b>
                  WERE ANY OF THESE SURCHARGED INDEPENDENT ATM TRANSACTIONS CONDUCTED WITH AN ATM OR PIN-DEBIT
                  CARD BUT NOT WITH A CREDIT OR GIFT CARD?*
                  <span style="color:red; font-weight:bold" class="required"> *This is Required</span>
                </b>
                <br />
                <div class="row">
                  <div class="col-md-12">
                      <div class="radio">
                        <label for="chargedUsingDebitCard">
                          <input type="radio" id="chargedUsingDebitCardYes" formControlName="chargedUsingDebitCard" (change)="getQuestionTwoValue($event)" name="chargedUsingDebitCard" value="Yes"><span style="font-weight:bold">Yes</span>
                        </label>
                      </div>
                      <div class="radio">
                        <label for="chargedUsingDebitCard">
                          <input type="radio" id="chargedUsingDebitCardNo" formControlName="chargedUsingDebitCard" (change)="getQuestionTwoValue($event)" name="chargedUsingDebitCard" value="No"><span style="font-weight:bold">No</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
            

              <div *ngIf="showQuestionThree == true">

                
                <br />
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="titleBold" for="estimatedTimesPaid" style="font-weight:bold">
                        ESTIMATE THE NUMBER OF TIMES BETWEEN OCTOBER 24, 2007, AND AUGUST 14, 2026, THAT YOU PAID AN UNREIMBURSED
                        SURCHARGE TO WITHDRAW CASH FROM AN INDEPENDENT ATM IN THE UNITED STATES USING AN ATM OR PIN-DEBIT CARD.:
                        <span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                      <input type="text" class="form-control" id="estimatedTimesPaid" formControlName="estimatedTimesPaid" placeholder=""
                             autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.estimatedTimesPaid.errors }" />
                      <div *ngIf="submitted && f.estimatedTimesPaid.errors" class="invalid-feedback">
                        <div *ngIf="f.estimatedTimesPaid.errors.minlength">This field must be at least 4 digits</div>
                        <div *ngIf="f.estimatedTimesPaid.errors.maxlength">This field must not be at greater 4 digits</div>
                        <div *ngIf="f.estimatedTimesPaid.errors.pattern">This field accepts only numerical digits 0-9</div>
                        <div *ngIf="f.estimatedTimesPaid.errors.required">This field is required</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br/><br/>
              <b>“AS STATED BELOW, THIS CLAIM FORM IS SUBMITTED UNDER PENALTY OF PERJURY, AND THE CLAIMS ADMINISTRATOR HAS THE
              RIGHT TO ASK YOU TO PROVIDE BANK STATEMENTS OR OTHER DOCUMENTS TO SUPPORT YOUR CLAIM.”</b>


            </div>
          </div>
         
         
          <br />
        
          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              CERTIFICATION
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12">
              By signing below, I certify, under penalty of perjury, that the information included on this claim form is
              accurate and complete to the best of my knowledge, information, and belief. If I am submitting this claim
              on behalf of a claimant, I certify that I am authorized to submit this claim form on the individual’s behalf.
              I am, or the individual on whose behalf I am submitting this claim is, a Class Member. I did not submit a
              request to exclude myself from, or “opt out of,” the Settlement with Visa and Mastercard. I agree (and consent)
              to be communicated with electronically via email and/or mobile phone text (message & data rates may apply). I
              agree to provide additional information about this claim if the Claims Administrator asks me to do so.
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid':  f.googleRecaptchaToken.errors }"></re-captcha>
                <div *ngIf="f.googleRecaptchaToken.errors" class="invalid-feedback">
                  <div *ngIf="f.googleRecaptchaToken.errors.required" style="color:red; font-size:80%">This field is required</div>
                </div>
                <!--<div style="color:#dc3545; font-size:80%; font-weight:bold">This field is required*</div>-->

              </div>
            </div>
          </div>
          <br />
       
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <label class="titleBold" for="signature">Electronic Signature:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.signature.errors }" />
                <div *ngIf="submitted && f.signature.errors" class="invalid-feedback">
                  <div *ngIf="f.signature.errors.required">This field is required</div>
                  <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.signature.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="titleBold" for="dateSigned">DATE: {{ today | date:'mediumDate' }}</label>
              
              </div>
              
            </div>
         
          </div>
          <br />
          <div class="row" *ngIf="showSubmittalErrorWarning" style="background-color:lightpink">
            <div class="col-md-12 text-center" style="font-weight:bold">
              Claim Submission Failed

            </div>
          </div>
          <br />
          <ul class="list-inline text-center">
            <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
          </ul>
        </form>
      </div>
    </div>
  </div>

























</div>
